import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Projects group's sub-navigation (PART 13): Projects List (PRJ-01),
 * Tasks (PRJ-02), Timesheets (PRJ-03), Project Billing (PRJ-04). One gate —
 * the projects permission area (§13.1.6, owner ruling R1).
 */
const TABS = [
  { to: '/projects', end: true, key: 'prj.tabProjects' },
  { to: '/projects/tasks', end: false, key: 'prj.tabTasks' },
  { to: '/projects/timesheets', end: false, key: 'prj.tabTimesheets' },
  { to: '/projects/billing', end: false, key: 'prj.tabBilling' },
] as const;

export function ProjectsTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navProjects')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
